
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1503Dialog extends Serenity.EntityDialog<Report_1503Row, any> {
        protected getFormKey() { return Report_1503Form.formKey; }
        protected getIdProperty() { return Report_1503Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1503Row.localTextPrefix; }
        protected getNameProperty() { return Report_1503Row.nameProperty; }
        protected getService() { return Report_1503Service.baseUrl; }
        protected getDeletePermission() { return Report_1503Row.deletePermission; }
        protected getInsertPermission() { return Report_1503Row.insertPermission; }
        protected getUpdatePermission() { return Report_1503Row.updatePermission; }

        protected form = new Report_1503Form(this.idPrefix);

    }
}